import { makePostRequest, OkResponse } from "../helpers"

export const activateSubscription = async (id: string) => {
    const result = await makePostRequest<OkResponse>(`api/subscriptions/${id}/activate`, {});
    
    return result?.data?.result;
}

export const cancelSubscription = async (id: string) => {
    const result = await makePostRequest<OkResponse>(`api/subscriptions/${id}/cancel`, {});

    return result?.data?.result;
}

export const removeSubscription = async (id: string): Promise<Record<string, string>> => {
    const result = await makePostRequest<OkResponse>(`api/subscriptions/${id}/remove`, {});
    
    return result?.data?.result;
}
